"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTranslation = exports.getIntl = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2022 GoodData Corporation
var isEmpty_1 = tslib_1.__importDefault(require("lodash/isEmpty"));
var react_intl_1 = require("react-intl");
var util_1 = require("@gooddata/util");
var en_US_json_1 = tslib_1.__importDefault(require("./bundles/en-US.json"));
var de_DE_json_1 = tslib_1.__importDefault(require("./bundles/de-DE.json"));
var es_ES_json_1 = tslib_1.__importDefault(require("./bundles/es-ES.json"));
var fr_FR_json_1 = tslib_1.__importDefault(require("./bundles/fr-FR.json"));
var ja_JP_json_1 = tslib_1.__importDefault(require("./bundles/ja-JP.json"));
var nl_NL_json_1 = tslib_1.__importDefault(require("./bundles/nl-NL.json"));
var pt_BR_json_1 = tslib_1.__importDefault(require("./bundles/pt-BR.json"));
var pt_PT_json_1 = tslib_1.__importDefault(require("./bundles/pt-PT.json"));
var zh_Hans_json_1 = tslib_1.__importDefault(require("./bundles/zh-Hans.json"));
var ru_RU_json_1 = tslib_1.__importDefault(require("./bundles/ru-RU.json"));
var Locale_1 = require("./Locale");
var messagesMap = {
    "en-US": util_1.translationUtils.removeMetadata(en_US_json_1.default),
    "de-DE": de_DE_json_1.default,
    "es-ES": es_ES_json_1.default,
    "fr-FR": fr_FR_json_1.default,
    "ja-JP": ja_JP_json_1.default,
    "nl-NL": nl_NL_json_1.default,
    "pt-BR": pt_BR_json_1.default,
    "pt-PT": pt_PT_json_1.default,
    "zh-Hans": zh_Hans_json_1.default,
    "ru-RU": ru_RU_json_1.default,
};
var intlStore = {};
/**
 * Gets react-intl's IntlShape set up for the provided locale.
 *
 * @param locale - one of the supported locales, if not specified returns shape for `DefaultLocale`
 * @internal
 */
function getIntl(locale) {
    if (locale === void 0) { locale = Locale_1.DefaultLocale; }
    var usedLocale = locale;
    if (isEmpty_1.default(locale)) {
        usedLocale = Locale_1.DefaultLocale;
    }
    return (intlStore[usedLocale] ||
        (intlStore[usedLocale] = react_intl_1.createIntl({
            locale: usedLocale,
            messages: messagesMap[locale],
        })));
}
exports.getIntl = getIntl;
/**
 * Convenience function to return translated and formatted string for given key and locale; optionally specify
 * values of parameters to substitute in the translated string.
 *
 * @param translationId - id of the localized string
 * @param locale - target locale
 * @param values - parameters, optional
 *
 * @internal
 */
function getTranslation(translationId, locale, values) {
    if (values === void 0) { values = {}; }
    var intl = getIntl(locale);
    return intl.formatMessage({ id: translationId, defaultMessage: translationId }, values);
}
exports.getTranslation = getTranslation;
//# sourceMappingURL=IntlStore.js.map